import { render, staticRenderFns } from "./ShowFactor.vue?vue&type=template&id=69e1b38a&scoped=true"
import script from "./ShowFactor.vue?vue&type=script&lang=js"
export * from "./ShowFactor.vue?vue&type=script&lang=js"
import style0 from "./ShowFactor.vue?vue&type=style&index=0&id=69e1b38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e1b38a",
  null
  
)

export default component.exports